import { Component, OnInit, OnDestroy, ViewRef } from '@angular/core';
import { StartQuoteService, UtilService, ApplicationDataCaptureService, SERVICE_END_POINT, AnalyticsService, FormValidationsService, AuthService } from 'src/app/shared';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { RefNo } from '../../model/ngrx/reference-number.model';
import { AppState } from '../../store/state/app.state';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { QuoteDataCaptureService, CURRENT_ENVIROMENT } from '../../shared';
import * as UserDataConfig from '../../common-components/config/user-data.config';
import { AlertModal } from '../../model/alert';
import { ActivatedRoute } from '@angular/router';
import { Location, NgClass } from '@angular/common';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { FormGroup } from '@angular/forms';
import { InvalidCtlNameObj } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import * as loggedInDetailActions from '../../store/actions/loggedin-detail.action';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { APP_URL } from 'src/app/shared/constants/url.constants';
import { ModalComponent } from '../modal/modal.component';
import { ModalOptionComponent } from '../modal-option/modal-option.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [NgClass, ModalOptionComponent, ModalComponent]
})
export class HeaderComponent implements OnInit {
  enableLoginButton: boolean = true;
  infoModalVisible = false;
  enableRegisterFeature: boolean = false;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  enableRefno = true;
  public contentData;
  protected serverDetail;
  public alertModalConfig: AlertModal;
  public displayAlert = false;
  firstName;
  textOverFlow;
  enableloginFeature = false;
  private helpModalElement: HTMLElement;
  subscription: any;
  private CMSData;
  public LGLogoLink;
  screenName;
  openPopup: boolean;

  @ViewChild("helpModal", { static: true }) helpTextFocus: ElementRef;
  isLocked: boolean = false;
  public lockedAlertModalConfig: AlertModal;
  public enableDropdown = false;
  constructor(private startQuoteService: StartQuoteService,
    private store: Store<AppState>,
    public router: Router,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private utilService: UtilService,
    private applicationDataCaptureService: ApplicationDataCaptureService,
    private analyticsService: AnalyticsService, private authService: AuthService) {
    this.serverDetail = UserDataConfig.BreadcrumbConfig.authServer;
    this.alertModalConfig = this.activatedRoute.snapshot.data.contentData.LoginModalConfig;
    this.contentData = this.activatedRoute.snapshot.data.contentData.headerData;
    this.lockedAlertModalConfig = this.activatedRoute.snapshot.data.contentData['modalConfigLocked'];
    this.referenceNumberStore = store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
      } else {
        this.referenceNumber = null;
      }
    });
    if (this.router.url.indexOf('/home/get-your-online-quote?dealPartner') > -1) {
      this.enableLoginButton = false;
    }
    if (this.router.url === '/home/logout' || this.router.url === '/home/registration') {
      this.enableRefno = false;
    }
    store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0 && res[0].customer.registrationStatus == true) {
        this.firstName = 'Hi '.concat(res[0].customer ? res[0].customer.forename : '');
        if (res.showWarning !== 'Y') {
          this.enableloginFeature = true;
        } else {
          this.enableloginFeature = false;
        }
      } else {
        this.enableloginFeature = false;
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        // tslint:disable-next-line: max-line-length
        if (this.router.url.indexOf('/home/you-will-need') > -1 || this.router.url.indexOf('/home/get-your-online-quote') > -1
          || this.router.url === '/quote/your-saved-quotes' || this.router.url === '/home/logout' || this.router.url === '/home/registration') {
          this.enableRefno = false;
        } else {
          this.enableRefno = true;
          // tslint:disable-next-line:align
        }
        this.infoModalVisible = false;
      });
    // tslint:disable-next-line:align
    this.formatFirstName(this.firstName);
  }

  toggleInfo = () => {
    this.analyticsService.eventTrack({ type: 'PhoneClick', name: '0800 048 2446', pageID: this.getCurrentScreenURL() });
    this.infoModalVisible = !this.infoModalVisible;
      this.helpModalElement = this.helpTextFocus.nativeElement;

      this.infoModalVisible ?
        (this.helpModalElement.tabIndex = 0,
          (document.querySelector('.Number_modal') as HTMLElement).focus())
        : (this.helpModalElement.tabIndex = -1,
          (document.querySelector('.phone-number') as HTMLElement).focus());
  }

  scrollInvalidForm(element: ElementRef) {
    if (element) {
      setTimeout(() => {
        const invalidElements = element.nativeElement.querySelectorAll('.form-validation-error');
        if (invalidElements.length > 0) {
          invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }
      }, 0);
    }
  }

  isBadDataPresent(): boolean {
    let badDataPresent = false;
    let obj: ParentFormAndElmModel = this.utilService.getParentFormToValidate();
    if (obj && obj.parentFormJustToClear) {
      FormValidationsService.clearFormErrors(obj.parentFormJustToClear);
    }
    if (obj && obj.parentFormToValidate && obj.parentElement) {
      FormValidationsService.clearFormErrors(obj.parentFormToValidate);
      if (obj.parentCdr && !(obj.parentCdr as ViewRef).destroyed) {
        obj.parentCdr.detectChanges();
      }
      let invalidDataObj: InvalidCtlNameObj = FormValidationsService.isInvalidDataFoundInForm(obj.parentFormToValidate);
      if (invalidDataObj && invalidDataObj.invalidDataPresent) {
        if (obj.emitInvalidEvtFlag) {
          this.utilService.emitInvalidMessageEvt(invalidDataObj);
        }
        else {
          FormValidationsService.validateAllFormForOneCtl(obj.parentFormToValidate, invalidDataObj.ctlName);
          this.scrollInvalidForm(obj.parentElement);
        }
        badDataPresent = invalidDataObj.invalidDataPresent;
      }
    }
    return badDataPresent;
  }
  openPopupModal (): void {
    this.openPopup = !this.openPopup;
   }


  public getScreenName(currentscreen): string {
    const breadcrumbDetails = UserDataConfig.BreadcrumbConfig.data.values;
    return breadcrumbDetails.find(br => br.screenName === currentscreen).path;
  }

  alertPrimaryBtnClick() {
    this.displayAlert = false;
    this.quoteDatacaptureService.postLoginCapture('Y', 'EAPCAANDGCDMISMATCH', '').subscribe(res => {
      if (res.showWarning === 'Y') {
        this.displayAlert = true;

      } else {
        const redirectUrl = this.getScreenName(res.currentScreen);
        this.router.navigate([redirectUrl]);
      }
    }, error => this.displayAlert = false);

  }
  alertSecondaryBtnClick() {
    this.displayAlert = false;
  }
  closeModal() {
    this.displayAlert = false;
  }


  logout() {
    if (this.isBadDataPresent()) {
      return;
    }
    this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
    let routerUrl = this.router.url;
    if (this.router.url.substr(1, 5) === 'apply') {
      this.applicationDataCaptureService.onLogoutClick(); // added this line for saving the data after logout
    } else if (this.referenceNumber == null) {
      this.authService.logout(routerUrl);
    } else {
      this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
        res => {
          if (res) {
            this.authService.logout(routerUrl);
          } else {
            if (this.router.url === APP_URL.user.homepage
              || this.router.url === APP_URL.user.youWillNeed
              || this.router.url === APP_URL.quote.yourSavedQuotes
              || this.router.url === APP_URL.quote.productQuote
            ) {
              this.authService.logout(routerUrl);
            } else {
              this.quoteDatacaptureService.onLogoutClick(); // added this line for saving the data after logout
            }
          }
        }
      );
    }
  }

  formatFirstName(firstName: string) {
    // tslint:disable-next-line:prefer-const
    let name: string;
    name = 'Hi '.concat(firstName);
    if (name.length > 15) {
      this.textOverFlow = 15;
    } else if (name.length >= 10 && name.length <= 15) {
      this.textOverFlow = 10;
    }

  }
  closeLockedModal() {
    this.isLocked = false;
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_HeaderAndFooter;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.LGLogoLink = this.CMSData.imageUrl_LandgLogo;
        this.contentData.yourRefNo = this.CMSData.string_YourRefNo;
        this.contentData.custService = this.CMSData.string_CustServs;
        this.contentData.timeInfo = this.CMSData.commonBlock.string_OpeningHrs;
        this.contentData.phoneNo = this.CMSData.commonBlock.string_CsPhoneNo;
        this.contentData.needHelpInfo = this.CMSData.string_NeedHelpPopupTitle;
        this.contentData.quoteLineInfo = this.CMSData.string_NeedHelpPopupInfo;
        this.contentData.okayInfo = this.CMSData.string_NeedHelpPopupCTALabel;
        this.contentData.loginText = this.CMSData.string_LoginCTALabel;
        this.contentData.registerText = this.CMSData.string_RegisterCTALabel;
        this.contentData.logoutText = this.CMSData.commonBlock.string_LogoutCTALabel;
        this.contentData.recordInfo = this.CMSData.commonBlock.string_RecordCallsInfo;
        this.contentData.updateDetails = this.CMSData.string_UpdateMyDetailsCTALabel;
        this.contentData.hereAreYourSavedQuotesText = this.CMSData.string_SavedQuotesCTALabel;
      }
    });
  }
  /** End of code block for CMS */
  navigateToUpdateMyDetails() {
    if (this.isBadDataPresent()) {
      return;
    }
    if (this.router.url === '/apply/your-pension-savings' || this.router.url === '/quote/your-product-quote') {
      this.applicationDataCaptureService.onSave('updatemyDetail');
      return;
    } else if (this.router.url.substr(1, 5) === 'apply') {
      // Makes save call for Apply Journey
      this.applicationDataCaptureService.onSave();
    } else {
      // Makes save call for Quote Journey
      if(this.router.url=== '/quote/your-saved-quotes'){
        this.quoteDatacaptureService.getScreenName();
       
      }else{
        this.quoteDatacaptureService.onSave();
      }
      
    }
    this.router.navigate(['/home/update-my-details']);
  }
  navigateToQuoteResult() {
    if (this.isBadDataPresent()) {
      return;
    }
    if (this.router.url === '/apply/your-pension-savings' || this.router.url === '/quote/your-product-quote') {
      this.applicationDataCaptureService.onSave('yoursavedquote');
      return;
    } else if (!((this.router.url).includes('your-product-application')) && this.router.url.substr(1, 5) === 'apply') {
      // Makes save call for Apply Journey
      this.applicationDataCaptureService.onSave();
    } else {
      // Makes save call for Quote Journey
      if (this.router.url === '/quote/your-product-options') {
        this.quoteDatacaptureService.onSave('your-product-options');
      } else {
        this.quoteDatacaptureService.onSave();
      }
    }
    if (this.router.url !== '/quote/your-product-options') {
      this.router.navigate(['/quote/your-saved-quotes']);
    }
  }
  goToHomePage() {
    this.router.navigate(['/home/get-your-online-quote']);
  }
  dropdownToggle() {
    this.enableDropdown = !this.enableDropdown;
  }
  /** For Web Analytics */
  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);

    return this.screenName;
  }
}
